import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import { NavigationList, NavigationListItem, NavigationListItemHeader, NavigationListItemFooter } from '@dbk/ui-list';
import Badge from '@dbk/ui-badge';
import { createContainer } from '@dbk-legacy/muster/react';
import { SELECTED_RANGE } from '../constants';
import { PALETTE } from '../../../../../../src/constants';

class ReportRMStatement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: 0,
      detailModel: true,
      loadingRow: null,
    };
  }

  /**
   * function: onRowClick will be called from Navigation List item.
   * It will route the screen to detail view of category list.
   */
  onRowClick = (index, docCategoryId, docCategoryName) => {
    this.setState({ selectedItem: index });
    this.props.setSelectedCategoryId(docCategoryId, docCategoryName);
  }

  /**
   * function: renderUnreadItem will render the Unread List item
   */
  renderUnreadItem = (unreadCount, totalDocumentCount) => {
    const { i18n: { messages } } = this.props;
    const index = 0;
    return <NavigationListItem testID="list_reports_unread_reportStatementRM_test"
      selected={this.state.selectedItem === index}
      style={this.state.selectedItem === index ? { borderColor: PALETTE.primaryActive } : null}
      onClick={() => this.onRowClick(index, -1)}>
      <span>
        <NavigationListItemHeader >
          {messages['app.chedelivery.reports.receivedFromRM_category']}
        </NavigationListItemHeader>
      </span>
      <div className="badge-size" id={"text_report_reportStatementRM_test_" + index}><span> <Badge value={unreadCount} /></span></div>

      <NavigationListItemFooter secondary style={{ overflow: 'visible', width: "100%" }} color={PALETTE.primaryInverseText}>{totalDocumentCount + " " + messages['app.chedelivery.reports.listitem']}</NavigationListItemFooter>


    </NavigationListItem>
  };

  /**
   * function: EDocumentView will render the eDocument View
   */
  renderEDocumentView = () => {
    const {
      reports: {
        selectedReportDetailsDateRange, totalDocs30Days,
        totalDocs7Days,
        totalDocsCustomRange,
        rm: {
          lastWeekTotalUnreadDocs, lastMonthTotalUnreadDocs,
          customRangeTotalUnreadDocs
        }
      }
    } = this.props;

    let totaltDocCount = 0;
    let totalUnreadCount = 0;
    if (selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
      totalUnreadCount = customRangeTotalUnreadDocs || 0;
      totaltDocCount = totalDocsCustomRange;
    }
    else {
      totalUnreadCount = (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) ? lastWeekTotalUnreadDocs : lastMonthTotalUnreadDocs;
      totaltDocCount = (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) ? totalDocs7Days : totalDocs30Days;
    }
    return (
      <NavigationList fullWidth style={{ paddingLeft: 20, paddingRight: 20 }}>
        {this.renderUnreadItem(totalUnreadCount, totaltDocCount)}
      </NavigationList>
    );
  }

  render() {
    return (
      <View>
        {this.renderEDocumentView()}
      </View>
    );
  }
}

ReportRMStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  selectedItem: PropTypes.bool,
  detailModel: PropTypes.bool,
  loadingRow: null,
};

ReportRMStatement.defaultProps = {
  i18n: {},
  selectedItem: PropTypes.bool,
  detailModel: PropTypes.bool,
  loadingRow: null,
};

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    setSelectedCategoryId: {
      $call: 'reports.setSelectedCategoryId'
    },
    reports: {
      totalUnreadDocs: true,
      totalDocs30Days: true,
      totalDocs7Days: true,
      totalDocsCustomRange: true,
      rm: {
        lastWeekTotalUnreadDocs: true,
        lastMonthTotalUnreadDocs: true,
        customRangeTotalUnreadDocs: true
      },
      selectedReportDetailsDateRange: true,
    },
  },
}
)(ReportRMStatement);
